import { makeStyles } from '@material-ui/core/styles';
import MaterialFormControl from '@material-ui/core/FormControl';

const useStyles = makeStyles((theme) => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  formControl: {
    marginBottom: theme.spacing(1),
    width: '100%',
  },
}));

export default function FormControl(props){
  const css = useStyles();
  return <MaterialFormControl className={props.className || css.formControl}>
    {props.children}
  </MaterialFormControl>
}
